export default __webpack_public_path__ + "static/media/error-504.8dee1d0c.svg";